import { render, staticRenderFns } from "./LoanApproval.vue?vue&type=template&id=4d7e00f0&scoped=true"
import script from "./LoanApproval.vue?vue&type=script&lang=js"
export * from "./LoanApproval.vue?vue&type=script&lang=js"
import style0 from "./LoanApproval.vue?vue&type=style&index=0&id=4d7e00f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7e00f0",
  null
  
)

export default component.exports